<template>
  <div v-if="productOptionImagesToDisplay.length || productOptionColorsToDisplay.length" class="flex items-center justify-center gap-x-1.5 py-2">
    <OnImg
      v-for="option in productOptionImagesToDisplay"
      :key="`${productId} ${option.name}`"
      :src="option.imageUrl!"
      :alt="option.name"
      :title="option.name"
      class="size-5 rounded-full border border-border-medium object-cover"
      :loading="lazyLoaded ? 'lazy' : undefined"
      decoding="async"
      sizes="md:20px lg:60px"
    />
    <span
      v-for="option in productOptionColorsToDisplay"
      :key="option.id"
      :style="{ backgroundColor: option.colorCode! }"
      :title="option.name ?? undefined"
      class="size-4 rounded-full border border-border-medium"
    />

    <!-- TODO(Indrek): Replace with a SVG to have better control over dot centering and sharpness -->
    <span
      v-if="productOptions.length > productOptionImagesToDisplay.length + productOptionColorsToDisplay.length"
      class="inline-block size-5 rounded-full border border-border-medium text-center"
    >
      <span class="inline-block -translate-y-1.5">&hellip;</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import OnImg from '~/components/on-img/OnImg.vue'
import type { HallProductOption } from './hall-product'

const props = withDefaults(
  defineProps<{
    productOptions: HallProductOption[]
    lazyLoaded?: boolean
    productId?: number | null
  }>(),
  {
    lazyLoaded: false,
    productId: null,
  }
)

const productOptionImagesToDisplay = computed(() => {
  if (!props.productOptions || props.productOptions.length < 2) {
    return []
  }

  const productOptionsWithImages = props.productOptions.filter((o) => o.imageUrl !== null && o.imageUrl !== '')

  if (productOptionsWithImages && productOptionsWithImages.length > 5) {
    return productOptionsWithImages.slice(0, 5)
  }

  return productOptionsWithImages
})

const productOptionColorsToDisplay = computed(() => {
  if (!props.productOptions || props.productOptions.length < 2) {
    return []
  }

  const productOptionsWithColors = props.productOptions.filter((o) => o.colorCode !== null && o.colorCode !== '')

  if (productOptionsWithColors && productOptionsWithColors.length > 5) {
    return productOptionsWithColors.slice(0, 5 - productOptionImagesToDisplay.value.length)
  }

  return productOptionsWithColors
})
</script>
